var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNavbarIcon1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.33285 18.502C3.33285 18.502 1.99951 18.502 1.99951 17.1686C1.99951 15.8353 3.33284 11.8353 9.99951 11.8353C16.6662 11.8353 17.9995 15.8353 17.9995 17.1686C17.9995 18.502 16.6662 18.502 16.6662 18.502H3.33285ZM9.99951 10.502C11.0604 10.502 12.0778 10.0805 12.8279 9.33038C13.5781 8.58024 13.9995 7.56282 13.9995 6.50195C13.9995 5.44109 13.5781 4.42367 12.8279 3.67353C12.0778 2.92338 11.0604 2.50195 9.99951 2.50195C8.93865 2.50195 7.92123 2.92338 7.17108 3.67353C6.42094 4.42367 5.99951 5.44109 5.99951 6.50195C5.99951 7.56282 6.42094 8.58024 7.17108 9.33038C7.92123 10.0805 8.93865 10.502 9.99951 10.502Z",
    fill: "#c3c3c3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNavbarIcon1);
export default __webpack_public_path__ + "static/media/navbar-icon1.feb83c697c2a7dd0273f634a972c3078.svg";
export { ForwardRef as ReactComponent };